<template>
  <div class="px-3">
    <v-chip-group
      mandatory
      v-model="statusIndex"
      active-class="primary--text"
      column
    >
      <v-chip
        >ที่ต้องแพ็ค
        <span v-if="stat.cooking != null" class="px-1">
          ({{ stat.cooking }})</span
        >
      </v-chip>
      <v-chip>
        รอเรียกรถ
        <span v-if="stat.ready_to_go != null" class="px-1">
          ({{ stat.ready_to_go }})</span
        ></v-chip
      >
      <v-chip>
        รอจัดส่ง
        <span v-if="stat.delivering != null" class="px-1">
          ({{ stat.delivering }})</span
        ></v-chip
      >
      <v-chip>
        กำลังจัดส่ง
        <span v-if="stat.completed != null" class="px-1">
          ({{ stat.completed }})</span
        ></v-chip
      >
    </v-chip-group>
    <!-- style="position:sticky; top:52px; background-color:white;" -->
    <v-sheet class="rounded-lg px-3 py-2 my-3">
      <v-row no-gutters>
        <v-col>
          <strong>เลขที่</strong>
        </v-col>
        <v-col> <strong>จำนวนชิ้น</strong></v-col>
        <v-col> <strong>ลูกค้า</strong></v-col>
        <v-col> <strong>ที่อยู่จัดส่ง</strong></v-col>
        <v-col> <strong>ไปรษณีย์</strong></v-col>
        <v-col :cols="2" class="text-right"></v-col>
      </v-row>
    </v-sheet>

    <v-sheet
      class="rounded-lg pa-3 my-2"
      v-for="(item, index) in orderList"
      :key="index"
    >
      <v-row no-gutters>
        <v-col align-self="center">
          <div>{{ item.order_id }} - {{ item.order_reference }}</div>
          <div>
            ต้องจัดส่งในวันที่
            <span v-bind:class="{ 'red--text': item.delay }">
              {{ item.datetime_received | moment("DD/MM/YYYY") }}
            </span>
          </div>
        </v-col>
        <v-col align-self="center">
          <div style="font-size:1.1rem">
            <v-chip label color="pink" dark>{{
              item.order_basket.product_list.length
            }}</v-chip>
          </div>
        </v-col>
        <v-col align-self="center">
          <div style="width: 120px">
            <template v-if="item.user_ref_json != null">
              <strong class="line-1-elipsis"
                >{{ item.user_ref_json.firstname }}
                {{ item.user_ref_json.lastname }}</strong
              >
              <div>
                <span class="font-xs">
                  <i class="fas fa-mobile-alt"></i>
                  {{ item.user_ref_json.mobile }}
                </span>
              </div>
            </template>
          </div>
        </v-col>
        <v-col align-self="center">
          <div style="width: 220px; padding: 10px 0">
            <div class="progress__title">
              <span v-if="item.user_address != null">{{
                item.user_address.label
              }}</span>
              <template v-if="item.user_address">
                <span v-if="item.user_address.place_detail != null">
                  {{ item.user_address.place_detail.address }}
                  {{ item.user_address.place_detail.sub_district }}
                  {{ item.user_address.place_detail.district }}
                  {{ item.user_address.place_detail.province }}
                </span>
              </template>
              <div v-if="item.tracking_number != null">
                Tracking : {{ item.tracking_number }}
              </div>
            </div>
          </div>
        </v-col>
        <v-col align-self="center">
          <div style="font-size:1.3rem">
            <strong>{{ item.user_address.place_detail.postcode }}</strong>
          </div>
        </v-col>
        <v-col :cols="2" class="text-right" align-self="center">
          <div v-if="item.status == 'processing'">
            <v-btn small rounded outlined color="primary" @click="print(item)"
              >พิมพ์ใบรายการ</v-btn
            >
          </div>
          <div v-if="item.status == 'cooking'">
            <v-btn
              small
              rounded
              outlined
              color="brown"
              @click="onShippingDialog(item)"
              dark
              >ใส่หมายเลขจัดส่ง</v-btn
            >
          </div>
          <div v-if="item.status == 'ready-to-go'">
            <v-btn
              small
              rounded
              outlined
              color="blue"
              @click="confirmShipping(item)"
              dark
              >ยืนยัน</v-btn
            >
          </div>
          <div v-if="item.status == 'delivering'">
            <v-btn
              small
              rounded
              outlined
              color="green"
              @click="confirmDelivering(item)"
              dark
              >ปิดงาน</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- RECEIPT DIALOG -->
    <el-dialog
      title="ใบรายการ"
      v-if="order != null"
      width="435px"
      center
      :visible.sync="recieptDialog"
    >
      <div id="print-area" class="mx-5" style="font-size: 0.8rem">
        <v-layout class="mb-5 mx-0" row wrap>
          <v-flex xs12>
            <el-row class="mt-2 subtitle">
              <el-col :span="12">
                <strong>หมายเลขออเดอร์ :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right"
                >{{ order.order_reference }}-{{
                  order.order_id | numFormat("00000")
                }}</el-col
              >
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>สร้างเมื่อ :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">{{
                order.created_at | moment("DD/MM/YYYY HH:mm")
              }}</el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ประเภทการสั่งซื้อ :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                <div v-if="order.order_type == 'pickup'">
                  <i class="fas fa-shopping-bag"></i> รับเองที่ร้าน
                </div>
                <div v-if="order.order_type == 'delivery'">
                  <i class="fas fa-motorcycle"></i> เดลิเวอรี่
                </div>
                <div v-if="order.order_type == 'commerce'">
                  <i class="fas fa-shopping-cart"></i> อีคอมเมิร์ซ
                </div>
                <div v-if="order.order_type == 'coupon'">
                  <i class="fas fa-ticket-alt"></i> คูปอง/วอเชอร์โค้ด
                </div>
                <div
                  v-if="
                    order.order_type == 'dinein' ||
                      order.order_type == 'dinein-buffet'
                  "
                >
                  <i class="fas fa-chair"></i> นั่งทานที่ร้าน
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>การชำระเงิน :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                <div v-if="order.payment_type == 'transfer'">โอนเงิน</div>
                <div v-if="order.payment_type == 'cash'">ชำระเงินสด</div>
                <div v-if="order.payment_type == 'qr'">พร้อมเพย์</div>
                <div v-if="order.payment_type == 'creditcard'">บัตรเครดิต</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ช่องทางการขาย :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                <div v-if="order.order_channel == 'liff'">
                  Line Official Account
                </div>
                <div v-else>{{ order.order_channel }}</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ข้อมูลลูกค้า :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                {{ order.user_ref_json.firstname }}
                {{ order.user_ref_json.lastname }}
                -
                <i class="fas fa-mobile-alt"></i>
                {{ order.user_ref_json.mobile }}
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ที่อยุ่จัดส่ง :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                {{ order.user_address.place_detail.address }}
                {{ order.user_address.place_detail.sub_district }}
                {{ order.user_address.place_detail.district }}
                {{ order.user_address.place_detail.province }}
                {{ order.user_address.place_detail.postcode }}
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>Sale Channel :</strong>
              </el-col>
              <el-col :span="12" class="text-right" style="text-align: right">
                {{ order.sale_channel }}
              </el-col>
            </el-row>
          </v-flex>
        </v-layout>

        <template v-if="order.order_basket.product_list.length > 0">
          <el-row
            :gutter="10"
            v-for="(item, index) in order.order_basket.product_list"
            v-bind:key="index"
          >
            <el-col :span="2" class="mb-3">
              <span>{{ item.quantity }} x</span>
            </el-col>
            <el-col :span="17" class="mb-3">
              {{ item.name }}
              <div v-if="item.modifiers != null">
                <div
                  class="modifiers"
                  style="padding-left: 20px"
                  v-for="(subject, index) in item.modifiers"
                  v-bind:key="index"
                >
                  {{ subject.title }}
                  <div v-if="!subject.duplicate">
                    <div v-for="(item, j) in subject.items" v-bind:key="j">
                      <li class="choice-item" v-if="item.checked">
                        {{ item.name }}
                      </li>
                    </div>
                  </div>
                  <div v-if="subject.duplicate">
                    <li v-for="(item, j) in subject.items" v-bind:key="j">
                      {{ item.name }} {{ item.checked }}
                    </li>
                  </div>
                </div>
              </div>
              <div class="mt-0" v-if="item.remark != null">
                Remark : {{ item.remark }}
              </div>
            </el-col>
            <el-col :span="5" class="mb-3 text-right" style="text-align: right"
              >฿
              {{
                (item.regular_price * item.quantity) | numFormat("0,0")
              }}</el-col
            >
          </el-row>
          <v-divider class="my-2"></v-divider>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าสินค้า</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿ {{ order.amount.food | numFormat("0,0.00") }}</el-col
            >
          </el-row>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">VAT</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿ {{ order.amount.vat | numFormat("0,0.00") }}</el-col
            >
          </el-row>

          <el-row
            :gutter="10"
            class="subtitle"
            v-if="order.amount.discount < 0"
          >
            <el-col :span="12" class="mb-3">ส่วนลด</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿ {{ order.amount.discount | numFormat("0,0.00") }}</el-col
            >
          </el-row>

          <el-row :gutter="10" class="title">
            <el-col :span="12" class="mb-2">รวม</el-col>
            <el-col :span="12" class="mb-2 text-right" style="text-align: right"
              >฿
              {{
                (parseFloat(order.amount.food) + parseFloat(order.amount.vat))
                  | numFormat("0,0.00")
              }}</el-col
            >
          </el-row>

          <v-divider class="my-2"></v-divider>

          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าจัดส่ง</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿
              {{
                (parseFloat(order.amount.delivery) +
                  parseFloat(order.amount.delivery_tax))
                  | numFormat("0,0.00")
              }}</el-col
            >
          </el-row>
          <el-row :gutter="10" class="subtitle" v-if="order.amount.extra > 0">
            <el-col :span="12" class="mb-2">ค่าบริการอื่นๆ</el-col>
            <el-col :span="12" class="mb-2 text-right" style="text-align: right"
              >฿ {{ order.amount.extra | numFormat("0,0.00") }}</el-col
            >
          </el-row>

          <el-row :gutter="10" class="title">
            <el-col :span="12" class="mb-3">รวมทั้งหมด</el-col>
            <el-col :span="12" class="mb-3 text-right" style="text-align: right"
              >฿
              {{ parseFloat(order.amount.total) | numFormat("0,0.00") }}</el-col
            >
          </el-row>
        </template>
        <div class="my-0 text-right" style="text-align: right">
          ***
          <span v-if="order.order_type == 'delivery'">จัดส่ง</span>
          <span v-if="order.order_type == 'pickup'">รับอาหาร</span>
          {{ order.datetime_received | moment("DD/MM/YYYY HH:mm") }}
        </div>
        <!--
        <div v-if="order.remark_public!=''" class="my-0 text-left">{{order.remark_public}} ***</div>
        -->
        <v-divider></v-divider>
        <!--
        <div v-if="order.payment_type=='cash'" class="my-3 text-center">
          <label>โปรดชำระเงินที่</label>
          <div>019-1-80933-5</div>
          <div>บจก. ฮาลาลไลซ์ | ธนาคารกสิกรไทย</div>
        </div>
        -->
        <div class="my-3 text-center" style="text-align: center">
          <div style="font-size: 2rem">Thank You</div>
        </div>
      </div>
      <v-btn block depressed color="primary" @click="print(order)"
        >พิมพ์ใบรายการ</v-btn
      >
    </el-dialog>

    <!-- SHIPPING DIALOG -->
    <el-dialog
      title="การจัดส่ง"
      v-if="selectedOrder != null"
      width="585px"
      center
      :visible.sync="shippingDialog"
    >
      <div>
        <div>
          <h2>
            หมายเลขออเดอร์ {{ selectedOrder.order_id }} -
            {{ selectedOrder.order_reference }}
          </h2>
        </div>
        <el-form :label-position="`top`" label-width="100px" size="mini">
          <el-form-item label="Courier">
            <el-col :span="19">
              <el-radio-group v-model="shippingForm.courier">
                <el-radio :label="`self_driver`">จัดส่งเอง</el-radio>
                <el-radio :label="`nim_express`">Nim Express</el-radio>
                <el-radio :label="`inter_express`">Inter Express</el-radio>
                <el-radio :label="`scg_express`">SCG Express</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-form>

        <div v-if="showSGCForm" class="grey lighten-3 rounded-lg my-5 px-4">
          <!-- {{ showSGCForm }} -->
        </div>
        <div v-else>
          <v-text-field
            v-model="shippingForm.tracking_number"
            placeholder="หมายเลขจัดส่ง หากจัดส่งเองให้ใส่เบอร์มือถือคนขับ"
            dense
            outlined
          ></v-text-field>
        </div>
      </div>

      <v-btn rounded block depressed color="primary" @click="ship"
        >ยืนยันการจัดส่ง</v-btn
      >
    </el-dialog>
  </div>
</template>
<script>
import Service from "@/services";
import moment from "moment";

export default {
  data() {
    return {
      recieptDialog: false,
      shippingDialog: false,
      statusIndex: 0,
      options: {
        page: 1,
        itemsPerPage: 200,
      },
      totalItems: 0,
      orderList: [],
      order: null,
      selectedOrder: null,
      shippingForm: {
        courier: "self_driver",
        status: "ready-to-go",
        tracking_number: "",
      },
      stat: {
        cooking: null,
        ready_to_go: null,
        delivering: null,
        completed: null,
      },
      loading: false,
      showSGCForm: false,
    };
  },
  watch: {
    statusIndex: {
      handler(value) {
        this.loadOrder();
      },
      deep: true,
    },

    shippingForm: {
      handler(value) {
        if (value.courier == "scg_express") {
          this.showSGCForm = true;
        } else {
          this.showSGCForm = false;
        }
      },
      deep: true,
    },
  },
  created() {
    this.loadOrder();
  },
  methods: {
    loadOrder() {
      this.showLoading();
      this.stat = {
        cooking: null,
        ready_to_go: null,
        delivering: null,
      };

      let status = "processing";
      if (this.statusIndex == 0) {
        status = "processing";
      } else if (this.statusIndex == 1) {
        status = "cooking";
      } else if (this.statusIndex == 2) {
        status = "ready-to-go";
      } else if (this.statusIndex == 3) {
        status = "delivering";
      }
      let params = {
        order_type: "commerce",
        begin: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        status: status,
        per_page: this.options.itemsPerPage,
        current_page: this.options.page,
      };

      if (this.search != null) {
        params.search = this.search;
      }

      if (
        ["processing", "cooking", "ready-to-go", "delivering"].includes(
          params.status
        )
      ) {
        params.sorting_key = "datetime_received";
        params.sorting_type = "asc";
      }

      this.orderList = [];
      Service.Order.getCommerceOrders(params).then((res) => {
        if (res.success) {
          this.hideLoading();
          this.totalItems = res.data.total;

          if (this.statusIndex == 0) {
            this.stat.cooking = this.totalItems;
          } else if (this.statusIndex == 1) {
            this.stat.ready_to_go = this.totalItems;
          } else if (this.statusIndex == 2) {
            this.stat.delivering = this.totalItems;
          } else if (this.statusIndex == 3) {
            this.stat.completed = this.totalItems;
          }

          this.orderList = res.data.rows.map((item) => {
            var currentDate = moment();
            let targetDate = moment(item.datetime_received);
            let delay = false;
            let postalcode = "";
            if (item.user_address.place_detail != null) {
              let s = item.user_address.place_detail.address.split(" ");

              if (!isNaN(s[s.length - 1])) {
                postalcode = s[s.length - 1];
              }

              if (item.user_address.place_detail.postcode) {
                postalcode = item.user_address.place_detail.postcode;
              }
            }

            if (targetDate.isBefore(currentDate)) {
              delay = true;
            }
            return { ...item, postalcode: postalcode, delay: delay };
          });

          /*
          this.orderList.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );
          */

          this.resultList = this.orderList;
        }
      });
    },
    onShippingDialog(item) {
      this.selectedOrder = item;
      this.shippingDialog = true;
    },
    ship() {
      this.showLoading();

      if (this.shippingForm.courier == "scg_express") {
        Service.Order.logistic(this.selectedOrder.order_id).then((res) => {
          this.shippingForm.tracking_number = "";
          this.shippingDialog = false;
          this.loadOrder();
        });
        return;
      }
      Service.Order.updateStatus(this.selectedOrder.order_id, this.shippingForm)
        .then((res) => {
          this.shippingForm.tracking_number = "";
          this.shippingDialog = false;

          this.loadOrder();

          // this.hideLoading();
        })
        .catch((e) => {
          this.hideLoading();
        });
    },
    confirmShipping(item) {
      this.showLoading();
      Service.Order.updateStatus(item.order_id, {
        status: "delivering",
      }).then((res) => {
        this.hideLoading();
      });
    },
    confirmDelivering(item) {
      this.showLoading();
      Service.Order.updateStatus(item.order_id, {
        status: "completed",
      }).then((res) => {
        this.hideLoading();
      });
    },
    print(item) {
      Service.Order.get(item.order_reference).then((res) => {
        if (!this.recieptDialog) {
          this.order = res.data;
          this.recieptDialog = true;
        }
        setTimeout(() => {
          this.$htmlToPaper("print-area", null, () => {
            this.recieptDialog = false;

            let data = {
              status: "cooking",
              remark_internal: "",
            };

            this.showLoading();
            Service.Order.updateStatus(item.order_id, data).then((res) => {
              this.loadOrder();
            });
          });
        }, 800);
        return;
      });
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    hideLoading() {
      this.loading.close();
    },
  },
};
</script>
